import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.progs = document.querySelectorAll('.navProgress');
    this.sections = document.querySelectorAll('.navSection');
    this.buttons = document.querySelectorAll('.navButton');

    window.addEventListener('scroll', this.updateProgress.bind(this));
    window.addEventListener('resize', this.updateProgress.bind(this));
    this.navigate();
  }

  updateProgress(){
    this.sections.forEach((section, i) => {
      const value = Math.max(0, -(section.getBoundingClientRect().top - 150))
      const total = section.offsetHeight
      const progress =  value / total * 100;

      if(progress <= 100 && progress > 0){
        this.buttons[i].classList.add('text-accent');
      } else {
        this.buttons[i].classList.remove('text-accent');
      }
      gsap.to(this.progs[i + 1], {height: `${progress}%`, duration: 0});
    })

    // First progress bar
    const prog1 = window.scrollY / (this.sections[0].getBoundingClientRect().top + window.scrollY -150) * 100;
    gsap.to(this.progs[0], {height: `${prog1}%`, duration: 0});


    // Last progress bar
    const lastSection = this.sections[this.sections.length - 1];
    const lastProg = this.progs[this.progs.length - 1];

    const lastValue = Math.max(0, -(lastSection.getBoundingClientRect().top - 150));
    const lastTotal = document.documentElement.scrollHeight - window.scrollY - window.innerHeight - (lastSection.getBoundingClientRect().top - 150);
    const prog2 = lastValue / lastTotal * 100;

    gsap.to(lastProg, {height: `${prog2}%`, duration: 0});
  }

  navigate(){
    this.buttons.forEach((button, i) => {
      button.addEventListener('click', () => {
        const offset = this.sections[i].getBoundingClientRect().top + window.scrollY - 149;
        window.scrollTo({top: offset, behavior: 'smooth'});
      })
    })
  }

}
